export default __webpack_public_path__ + "static/media/jin_woo_lee.93585c4e.png";